function selectAllGroup(props) {
  var arrayPredicate = props.arrayPredicate,
    data = props.data,
    fieldPredicate = props.fieldPredicate,
    index = props.index,
    layout = props.layout,
    propertyPrefix = props.propertyPrefix,
    uiSchema = props.uiSchema;
  return layout.reduce(function (acc, item) {
    var id = item.id,
      type = item.type;
    var uiSchemaProp = uiSchema[id];
    var childType = uiSchemaProp && !!uiSchemaProp['dm:layout'] ? 'object' : type;
    switch (childType) {
      case 'field':
        if (fieldPredicate(id, props)) {
          acc["".concat(propertyPrefix).concat(id)] = index;
        }
        break;
      case 'object':
        Object.assign(acc, selectAllGroup(Object.assign({}, props, {
          data: data[id],
          layout: uiSchemaProp['dm:layout'],
          propertyPrefix: "".concat(propertyPrefix).concat(id, "."),
          uiSchema: uiSchemaProp
        })));
        break;
      case 'group':
        if (item.children && item.children.length > 0) {
          Object.assign(acc, selectAllGroup(Object.assign({}, props, {
            layout: item.children
          })));
        }
        break;
      case 'array':
        if (arrayPredicate(id, props)) {
          acc[id] = !data[id] ? {} : data[id].reduce(function (entry, val, row) {
            entry["r".concat(row, "-c").concat(index)] = true;
            return entry;
          }, {});
        }
        break;
      default:
        break;
    }
    return acc;
  }, {});
}
function select(props) {
  var record = props.record;
  var uiSchema = record.uiSchema,
    data = record.data;
  return selectAllGroup(Object.assign({
    arrayPredicate: function arrayPredicate() {
      return true;
    },
    data: data,
    fieldPredicate: function fieldPredicate() {
      return true;
    },
    layout: uiSchema['dm:layout'],
    uiSchema: uiSchema,
    propertyPrefix: ''
  }, props));
}
export function selectAll(index, record) {
  return select({
    index: index,
    record: record
  });
}
export function arrayHasAllEnabledFields(id, uiSchema) {
  var items = uiSchema[id].items;
  return Object.keys(items).reduce(function (acc, key) {
    return acc && !items[key]['ui:disabled'];
  }, true);
}
export function selectAllDisabled(index, record) {
  return select({
    fieldPredicate: function fieldPredicate(id, _ref) {
      var uiSchema = _ref.uiSchema;
      return uiSchema[id]['ui:disabled'];
    },
    arrayPredicate: function arrayPredicate(id, _ref2) {
      var uiSchema = _ref2.uiSchema;
      return !arrayHasAllEnabledFields(id, uiSchema);
    },
    index: index,
    record: record
  });
}
export function selectAllEnabled(index, record) {
  return select({
    fieldPredicate: function fieldPredicate(id, _ref3) {
      var uiSchema = _ref3.uiSchema;
      return !uiSchema[id]['ui:disabled'];
    },
    arrayPredicate: function arrayPredicate(id, _ref4) {
      var uiSchema = _ref4.uiSchema;
      return arrayHasAllEnabledFields(id, uiSchema);
    },
    index: index,
    record: record
  });
}
export default {
  selectAllGroup: selectAllGroup,
  select: select,
  selectAll: selectAll,
  arrayHasAllEnabledFields: arrayHasAllEnabledFields,
  selectAllDisabled: selectAllDisabled,
  selectAllEnabled: selectAllEnabled
};